
import Vue from "vue";
import BigStar from "@/components/rating/BigStar.vue";

type StarRating = {
  key: number;
  value: number;
};
export default Vue.extend({
  components: {
    BigStar,
  },
  props: {
    editable: {
      required: true,
      type: Boolean,
    },
    value: Number,
  },
  data: () => ({
    data: 0,
  }),
  created() {
    this.data = this.value ?? 5;
  },
  methods: {
    onChangeRate(rate: number) {
      if (this.editable) {
        this.data = rate;
        this.$emit("change-rate", this.data);
      }
    },
  },
  computed: {
    rating(): StarRating[] {
      const rate = [0, 0, 0, 0, 0];
      return rate.map((val, idx) => {
        const index = idx + 1;
        if (index <= this.data) {
          return { key: index, value: 1 };
        }
        if (index > Math.ceil(this.data)) {
          return { key: index, value: 0 };
        }
        return { key: index, value: this.data % 1 };
      });
    },
  },
  watch: {
    value() {
      this.data = this.value;
    },
  },
});
